import { jsx as l } from "react/jsx-runtime";
const a = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M21.885 14.663a4.72 4.72 0 0 1-4.762 4.317h-2.627l-5.002 3.25v-3.25H6.868a4.724 4.724 0 0 1-4.753-4.32 60 60 0 0 1 .038-8 4.65 4.65 0 0 1 4.31-4.24 78 78 0 0 1 5.532-.19c1.876 0 3.752.062 5.533.19a4.65 4.65 0 0 1 4.32 4.25c.19 2.66.202 5.33.037 7.993M8.077 7.55c.258-1 1.679-1 1.937 0l.278 1.079a1 1 0 0 0 .719.718c.649.168 1.33.168 1.979 0a1 1 0 0 0 .718-.718l.278-1.08c.258-1 1.68-1 1.937 0l.278 1.08a1 1 0 0 0 .719.718l1.079.279c1 .258 1 1.678 0 1.936l-1.079.279a1 1 0 0 0-.719.718l-.278 1.08c-.258 1-1.678 1-1.937 0l-.278-1.08a1 1 0 0 0-.718-.718 3.96 3.96 0 0 0-1.98 0 1 1 0 0 0-.718.718l-.278 1.08c-.258 1-1.679 1-1.937 0l-.278-1.08a1 1 0 0 0-.719-.718l-1.079-.279c-1-.258-1-1.678 0-1.936l1.08-.279a1 1 0 0 0 .718-.718z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  a as default
};
